import { isTestEnv } from "@backmarket/utils/env/isTestEnv";
import { IntlMessageFormat } from "intl-messageformat";
import { CLIENT_GLOBAL_KEY, PROCESS_KEY } from "../../constants.js";
function isI18nOptions(obj) {
  return !!obj && typeof obj === "object" && "logMissingTranslation" in obj;
}
export default function createMessageFormatter({
  locale,
  showTranslationKeys = false,
  showDefaultMessage = false,
  currencyCode,
  shouldLogMissingTranslationValue = true
}) {
  return (definition, valuesOrOptions, optionsIfValues) => {
    let values;
    let options;
    if (valuesOrOptions) {
      if (isI18nOptions(valuesOrOptions)) {
        options = valuesOrOptions;
      } else {
        values = valuesOrOptions;
        options = optionsIfValues;
      }
    }
    if (!definition) {
      console.error("[nuxt-module-i18n] Missing translation definition", {
        locale
      });
      return null;
    }
    if (showTranslationKeys) {
      return definition.id;
    }
    try {
      if (import.meta.server && // Intl cache exists for this definition
      globalThis[PROCESS_KEY]?.translationsByLocaleCache[locale]?.messages[definition.id] && // Raw definition is not an empty string (not checking this in the cache as an empty string parses to a truthy AST value)
      globalThis[PROCESS_KEY]?.translationsByLocale[locale]?.[definition.id] && // Intl doesn't support forcing default message
      !showDefaultMessage) {
        const intl = globalThis[PROCESS_KEY]?.translationsByLocaleCache[locale];
        return intl?.formatMessage(definition, values);
      }
      const translation = import.meta.server ? globalThis[PROCESS_KEY]?.translationsByLocale[locale]?.[definition.id] : globalThis[CLIENT_GLOBAL_KEY]?.translations?.[definition.id];
      if (!showDefaultMessage && !translation && !isTestEnv()) {
        if (translation === void 0) {
          console.error("[nuxt-module-i18n] Missing translation key", {
            definition,
            locale
          });
        } else if (translation === "" && (options?.logMissingTranslation ?? shouldLogMissingTranslationValue)) {
          console.error("[nuxt-module-i18n] Missing translation value", {
            definition,
            locale
          });
        }
      }
      const raw = !showDefaultMessage && translation ? translation : definition.defaultMessage;
      const escaped = raw.replace(/{(\w*), html}/g, "'{$1}'");
      const message = new IntlMessageFormat(escaped, locale, {
        number: {
          currency: {
            style: "currency",
            currency: currencyCode
          }
        }
      });
      return message.format(values);
    } catch (error) {
      console.error("[nuxt-module-i18n] - createMessageFormatter", {
        definition,
        locale,
        error
      });
      return null;
    }
  };
}
